<template>
  <md-dialog :md-closed="closeDialog" :md-opened="openDialog" class="" :md-close-on-esc="false"
             :md-click-outside-to-close="false"
             :md-active.sync="options.showSuppliersForm">
    <md-dialog-title class="ml-30 mt-20">
      {{ currentSupplier ? options.Lang.Supplier_bearbeiten : options.Lang.Neuen_Supplier_anlegen }}

    </md-dialog-title>
    <md-dialog-content>
      <div class="pt-30 pl-30">
        <form novalidate class="md-layout" @submit.prevent="validate">
          <div class="md-layout-item">
            <div>
              <md-field class="md-focused" :class="getValidationClass('supplier_name')">
                <label for="supplier_name">{{options.Lang.Supplier_Name}}<span class="md-required">*</span></label>
                <md-input tabindex="4" name="supplier_name" :placeholder="options.Lang.Supplier_Name" id="supplier_name"
                          v-model="form.supplier_name"
                          :disabled="sending"/>
                <span class="md-error" v-if="!$v.form.supplier_name.required">{{ options.Lang.Bitte_ausfüllen }}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout-item">
            <div>
              <md-field class="md-focused" :class="getValidationClass('email')">
                <label for="email">E-Mail<span class="md-required">*</span></label>
                <md-input tabindex="0" name="email" placeholder="E-Mail-Adresse" id="email" v-model="form.email"
                          :disabled="sending"/>
                <span class="md-error" v-if="!$v.form.email.required">{{ options.Lang.Bitte_ausfüllen }}</span>
              </md-field>
            </div>
            <div class="pt-80 mt-7">

            </div>
          </div>
        </form>
      </div>
    </md-dialog-content>
    <md-dialog-actions class="mt-20">
      <div class="p-20">
        <md-button tabindex="7" class="md-raised md-primary" @click="save"><strong>{{
            currentSupplier ? options.Lang.Supplier_bearbeiten :
                options.Lang.Neuen_Supplier_anlegen
          }}</strong>
        </md-button>
        <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{options.Lang.Abbrechen}}</strong></md-button>
      </div>
    </md-dialog-actions>
    <Success :options="options"></Success>
  </md-dialog>
</template>

<script>
import {validationMixin} from 'vuelidate'
import { required, } from 'vuelidate/lib/validators'
import Success from '../../components/dialogs/Success.vue'


export default {
  name: 'formImportTrip',
  mixins: [validationMixin],
  components: {
    Success
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentSupplier: {
      type: Object
    },
  },
  data: () => ({
    supplier: null,
    form: {
      supplier_name: null,
      email: null,
    },
    supplierSaved: false,
    sending: false,
  }),
  validations: {
    form: {
      supplier_name: {
        required,
      },
      email: {
        required,
      },
    }
  },
  created() {
  },
  mounted() {
    this.supplier = this.currentSupplier;
  },
  watch: {
    currentSupplier: {
      handler(newValue) {
        //console.log(newValue);
        if (newValue) {
          let self = this;
          self.supplier = newValue ? newValue : null;
          self.form.id = newValue ? newValue.id : null;
          self.form.supplier_name = newValue ? newValue.supplier_name : null;
          self.form.email = newValue ? newValue.email : null;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm() {
      this.$v.$reset()
      this.form.id = null
      this.form.supplier_name = null
      this.form.email = null
      this.currentSupplier = null
      this.supplier = null
    },
    save() {
      const self = this;
      //console.log('test');
      self.$v.$touch()
      if (self.$v.$invalid) {
        //console.log('test');
        return false;
      }
      self.sending = true;
      this.doPost({
        userdata: self.options.user,
        data: self.form
      }, (self.currentSupplier ? 'updateSupplier' : 'createSupplier'), function (res) {
        self.sending = false;
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.showSuccess = true;
          self.$emit('updateData', {});
          self.closeDialog();
        }
      });
    },
    openDialog() {

    },
    closeDialog() {
      this.clearForm();
      this.options.showSuppliersForm = false;
      this.options.currentSupplier = null
    },
    validate() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.save()
      }
    }
  }
}
</script>
<style>
#supplier_name{
  -webkit-text-fill-color: black !important;
}
</style>